module.exports = __webpack_public_path__ + "static/circlegrey-312f770676d85092866a266bf7d82281.svg";